import t from "./index846.js";
import a from "./index813.js";
import u from "./index795.js";
import o from "./index894.js";
import e from "./index818.js";
import g from "./index856.js";
function P(r, m, s) {
  m = t(m, r);
  for (var n = -1, i = m.length, f = !1; ++n < i; ) {
    var l = g(m[n]);
    if (!(f = r != null && s(r, l)))
      break;
    r = r[l];
  }
  return f || ++n != i ? f : (i = r == null ? 0 : r.length, !!i && e(i) && o(l, i) && (u(r) || a(r)));
}
export {
  P as default
};
